import "reflect-metadata";
import { lazy } from "react";
import { injectable, registry } from "tsyringe";
import { FeatureSetupDef, FeatureRootRoute, FeatureSetup } from "@app/types/feature.types";
import { featurePaths } from "@feature/constants/paths.constant";
import { version, name } from "@feature/package.json";
import { FeatureToken } from "@app/constants/di";


const MstrCompanypage = lazy(() => import("@feature/pages/company/MstrCompany"));
const MstrLocationpage = lazy(() => import("@feature/pages/location/MstrLocation"));
const MstrDepartmentpage = lazy(() => import("@feature/pages/department/MstrDepartment"));
const MstrChargeCodepage = lazy(() => import("@feature/pages/chargecode/MstrChargeCode"));
const MstrShowPrefixpage = lazy(() => import("@feature/pages/showprefix/MstrShowPrefix"));
const MstrTransportCodepage = lazy(() => import("@feature/pages/transportcode/MstrTransportCode"));
const MstrVatTaxpage = lazy(() => import("@feature/pages/vattax/MstrVatTax"));
const MstrOrganizerListpage = lazy(() => import("@feature/pages/organizer/OrganizerList"));
const VenueListPage = lazy(() => import("@feature/pages/venue/MstrVenue"));
const DSVOfficeListPage = lazy(() => import("@feature/pages/dsvoffice/MstrDSVOffice"));

@injectable()
@registry([{ token: FeatureToken, useClass: MstrCompany }])
class MstrCompany implements FeatureSetupDef {
    GetFeatureSetup(): FeatureSetup {
        return {
            version,
            namespace: name,
            featuresRoot: this.features,
            permissions: [],
            index: true
        };
    }
    private readonly features: FeatureRootRoute = {
        requiredPermissions: [],
        children: [
            {
                title: "Company",
                path: featurePaths.comapanylist,
                page: MstrCompanypage
            },
             {
                title: "Location",
                path: featurePaths.locationlist,
                page: MstrLocationpage
            },
            {
                title: "Department",
                path: featurePaths.departmentlist,
                page: MstrDepartmentpage
            },
            {
                title: "Charge Code",
                path: featurePaths.chargecodelist,
                page: MstrChargeCodepage
            },
             {
                title: "Show Prefix",
                path: featurePaths.showprefixslist,
                page: MstrShowPrefixpage
            },
            {
                title: "Tax",
                path: featurePaths.vattaxlist,
                page: MstrVatTaxpage
            },
            {
                title: "Transport Code",
                path: featurePaths.transportcodelist,
                page: MstrTransportCodepage
            },             
            {
                title: "Organizer",
                path: featurePaths.organizerList,
                page: MstrOrganizerListpage
            },            {
                title: "Venue",
                path: featurePaths.venueList,
                page: VenueListPage
            },
            {
                title: "DSV Office",
                path: featurePaths.dsvofficeList,
                page: DSVOfficeListPage
            },
           
        ]
    };
}
